// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"a123b4c9","453":"0131fb4f"}[chunkId] + ".chunk.js";
};